




















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

import { Meta } from '@/decorators';
import i18n from '@/i18n';
import store from '@/store';
import EventBus from '@/plugins/event-bus';

import BackgroundImage from '@/components/ui/BackgroundImage.vue';

import ContactForm from '@/components/blocks/contact/ContactForm.vue';
import TeamMembers from '@/components/blocks/contact/TeamMembers.vue';

import IContactMeta from '@/store/modules/contact/types/IContactMeta';
import IContactHeader from '@/store/modules/contact/types/IContactHeader';
import ITeamMember from '@/store/modules/contact/types/ITeamMember';


async function dataHook(to: Route, from: Route, next: (callback?: any) => void) {
  try {
    await store.dispatch('contact/load');
    next(true);
  } catch (error) {
    store.commit('app/error', error, { root: true });
    next({ path: '/error' });
  }
}

@Component({
  components: {
    BackgroundImage,
    ContactForm,
    TeamMembers,
  },
})
export default class Contacts extends Vue {
  private get meta(): IContactMeta {
    return this.$store.state.contact.meta;
  }

  private get header(): IContactHeader {
    return this.$store.state.contact.header;
  }

  private get team(): ITeamMember[] {
    return this.$store.state.contact.team;
  }

  @Meta
  public metaInfo() {
    return {
      title: this.meta.title,
       meta: [{
        vmid: 'description',
        name: 'description',
        content: this.meta.description,
      }],
    };
  }

  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (callback?: any) => void) {
    await dataHook(to, from, next);
  }
}
